﻿package com.mgacreative.hotel.feature.hotel.di

import com.mgacreative.hotel.feature.hotel.router.AppRouter
import com.mgacreative.hotel.feature.hotel.ui.auth.AuthNavigator
import com.mgacreative.hotel.feature.hotel.ui.auth.AuthViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getHotelFeatureModule() = module {
    single { AppRouter() }
    single { AuthNavigator() }
    viewModel { AuthViewModel(get(), get(), get(), get()) }
}
